export default __webpack_public_path__ + "static/media/festac-terminal.3f4b3ed5.png";